import * as React from 'react';
import { useState, useEffect } from 'react';
import Modal from '../../components/modal';
import { StyleSheet, Platform, Picker as rnPicker, Alert } from 'react-native';
import { ListItem, Right, Left, Text, View, Header, Button, Icon, Body, Title, Spinner, Content, Thumbnail, Footer, Picker as nbPicker } from 'native-base';
import { renderPicker as PickerComp } from '../../forms/renderedComponents';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import CalCalDataApi from '../../api/CalCalDataApi';

const Picker = Platform.OS == 'ios' ? nbPicker : rnPicker;

export default function AccountPopup({ account, jwt, onClosed }) {
	const [submitting, setSubmitting] = useState(false);
	const [calcalAcc, setCalcalAcc] = useState();

	useEffect(() => {
		if (account?.calcalId) setCalcalAcc(account.calcalId);
	}, [account]);

	const dispatch = useDispatch();

	const { accounts } = useSelector(
		state => ({
			accounts: state.globalReducer.accounts
		}),
		shallowEqual
	);

	const save = () => {
		//we can only save the linked calcal account
		setSubmitting(true);
		__DEV__ && console.log(calcalAcc, account.calcalId);

		//update the 'bankimport account'

		CalCalDataApi.dataUpdate('bankimport/account/' + account.account_id, { calcalId: calcalAcc }, jwt, res => {
			//console.log('handleSubmit ', res);
			if (res.success) {
				dispatch({
					type: 'UPDATE/account', //successful update send UPDATE(d) to store
					difference: { tink_id: account.account_id }, //IF no JSON returned, trust local changes
					id: calcalAcc
				});
				if (account.calcalId)
					dispatch({
						type: 'UPDATE/account', //successful update send UPDATE(d) to store
						difference: { tink_id: null }, //IF no JSON returned, trust local changes
						id: account.calcalId
					});
				setSubmitting(false);
				onClosed();
			} else if (res.validationErrors) {
				console.log('validationErrors ', res.validationErrors);
			}
		});
	};

	const onChangeAccount = acc => {
		__DEV__ && console.log(acc);
		setCalcalAcc(acc);
	};

	return (
		<Modal isOpen={!!account} backButtonClose coverScreen swipeThreshold={100} style={styles.modalStyle} onClosed={onClosed}>
			<View style={styles.modalContainer}>
				<Header style={styles.modalHeader}>
					<Button
						transparent
						onPress={() => {
							setSubmitting(false);
							onClosed();
						}}>
						<Icon name="close" />
					</Button>

					<Body style={{ flexDirection: 'row' }}>
						<Title style={{ alignSelf: 'center', marginLeft: 20 }}>{account?.name}</Title>
					</Body>

					{submitting ? (
						<Spinner />
					) : (
						<Button transparent onPress={save}>
							<Icon name="checkmark" />
						</Button>
					)}
				</Header>
				{!!account && (
					<Content>
						<View padder style={{ flexDirection: 'row' }}>
							<Left>
								<Text>Account Number</Text>
							</Left>
							<Body>
								<Text style={{ textAlign: 'right' }}>****{account.mask}</Text>
							</Body>
						</View>
						<View padder style={{ flexDirection: 'row' }}>
							<Left>
								<Text>Balance</Text>
							</Left>
							<Body>
								<Text style={{ textAlign: 'right' }}>
									{account.balances?.current < 0 && '- '}
									{account.balances?.iso_currency_code?.replace('GBP', '£') + Math.abs(account.balances?.current).toFixed(2)}
								</Text>
							</Body>
						</View>
						<View padder style={{ flexDirection: 'row' }}>
							<Left>
								<Text>Available Credit</Text>
							</Left>
							<Body>
								<Text style={{ textAlign: 'right' }}>
									{account.balances?.available < 0 && '- '}
									{account.balances?.iso_currency_code.replace('GBP', '£') + Math.abs(account.balances?.available).toFixed(2)}
								</Text>
							</Body>
						</View>
						{account.balances?.limit && (
							<View padder style={{ flexDirection: 'row' }}>
								<Left>
									<Text>Credit Limit</Text>
								</Left>
								<Body>
									<Text style={{ textAlign: 'right' }}>
										{account.balances?.limit < 0 && '- '}
										{account.balances?.iso_currency_code.replace('GBP', '£') + Math.abs(account.balances?.limit).toFixed(2)}
									</Text>
								</Body>
							</View>
						)}
						<View padder style={{ flexDirection: 'row' }}>
							<Left>
								<Text>Type</Text>
							</Left>
							<Body>
								<Text>{account.type}</Text>
							</Body>
						</View>
						<ListItem>
							<Left>
								<Text>Linked to</Text>
							</Left>
							<Body>
								<Picker
									prompt={'Select Account'}
									iosHeader={'Select Account'}
									style={{ flex: 1, borderWidth: 0, backgroundColor: 'transparent', maxWidth: '100%', paddingVertical: 10 }}
									selectedValue={calcalAcc}
									onValueChange={v => onChangeAccount(v)}>
									{!account.calcalId && <Picker.Item key="none" label=" - Select Account - " value={null} />}
									{!!accounts && accounts.filter(v => !v.tink_id || v.id == account.calcalId).map((item, i) => <Picker.Item key={i} label={item.nickName} value={item.id} />)}
								</Picker>
							</Body>
						</ListItem>
					</Content>
				)}
				{false && (
					<Footer style={{ justifyContent: 'space-between' }}>
						<Button danger style={{ flex: 1 }}>
							<Text>Remove Account</Text>
						</Button>
						<Button transparent style={{ flex: 1 }}>
							<Text></Text>
						</Button>
					</Footer>
				)}
			</View>
		</Modal>
	);
}

const styles = StyleSheet.create({
	modalStyle: {
		borderRadius: 10,
		alignItems: 'center',
		width: '90%',
		maxHeight: '70%'
	},
	modalContainer: { flex: 1, backgroundColor: '#EEE', width: '100%', borderTopLeftRadius: 10, borderTopRightRadius: 10 },

	modalHeader: { height: 70, borderTopLeftRadius: 10, borderTopRightRadius: 10 }
});
